import { Spacer, Text } from '@vapor/ui';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { Content } from '../components/boxes/content';
import { termsOfService } from '../content/termsOfService';
import { MarketingLayout } from '../layout/marketing';

export default function Terms() {
  let [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window == 'undefined') return;

    setTimeout(() => {
      setShow(true);
    }, 500);
  }, []);

  return (
    <MarketingLayout>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      <Content style={{ maxWidth: 800 }}>
        <Text as="h1" size={40} weight={600}>
          Terms Of Service
        </Text>

        <Spacer height={20} />

        <div dangerouslySetInnerHTML={{ __html: show ? termsOfService : '' }} />
      </Content>
    </MarketingLayout>
  );
}
